<template>
    <v-dialog
        v-model="$store.state.dispatch.shiftSummary"
        hide-overlay
        persistent
        max-width="1200px"
        transition="dialog-bottom-transition"
    >
        <v-card tile style="border-radius:0px;">
            <v-toolbar color="#01579b" dense class="toolbar-container">
                <v-col style="margin: 0px 6px; padding: 0px 6px;">
                    <v-menu
                        v-if="orderDataReady"
                        :close-on-content-click="false"
                        :nudge-width="700"
                        offset-y
                        max-height="700"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-if="
                                    EmailCounter == 0 ||
                                        thereAreDiffs ||
                                        NewShiftInfo.generalShiftData
                                            .DriverEleosApp != 1
                                "
                                color="#01579b"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon left>mdi-email</v-icon> Send
                            </v-btn>
                            <v-btn
                                v-else
                                color="#01579b"
                                dark
                                @click="showAlert"
                            >
                                <v-icon left>mdi-email</v-icon> Send
                            </v-btn>
                        </template>

                        <v-card
                            v-if="
                                EmailCounter == 0 ||
                                    NewShiftInfo.generalShiftData
                                        .DriverEleosApp != 1
                            "
                            style="width: 800px; padding: 30px;"
                        >
                            <v-list>
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <img
                                            src="../../../../assets/logo.png"
                                            alt="UPT"
                                        />
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title
                                            style="margin-top: 10px;"
                                            >United Petroleum
                                            Transport</v-list-item-title
                                        >
                                        <v-list-item-subtitle>
                                            <v-text-field
                                                style="padding: 0;"
                                                v-model="from"
                                                :rules="[rules.email]"
                                                hide-details
                                                :readonly="true"
                                            ></v-text-field>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>

                                    <v-list-item-action>
                                        <v-btn
                                            color="#01579b"
                                            dark
                                            @click="emailConfirm(ShiftDetail)"
                                        >
                                            <v-icon left
                                                >mdi-check-circle</v-icon
                                            >
                                            Send Mail
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>

                            <v-divider></v-divider>

                            <v-list>
                                <v-list-item>
                                    <v-text-field
                                        style="padding: 0;"
                                        v-model="to"
                                        :rules="[rules.email]"
                                        hide-details
                                        :readonly="true"
                                    >
                                        <template #prepend-inner>
                                            <span style="padding: 5px 50px 0 0;"
                                                >To:
                                            </span>
                                        </template>
                                    </v-text-field>
                                </v-list-item>

                                <v-list-item>
                                    <v-text-field
                                        style="padding: 0;"
                                        v-model="cc"
                                        placeholder="Example: email1@upt.com;email2@gmail.com;email3@upt.com;"
                                        hide-details
                                    >
                                        <template #prepend-inner>
                                            <span style="padding: 5px 47px 0 0;"
                                                >CC:
                                            </span>
                                        </template>
                                    </v-text-field>
                                </v-list-item>

                                <v-list-item>
                                    <v-text-field
                                        style="padding: 0;"
                                        v-model="subject"
                                        placeholder="Example: Friday, December 23, 2022 PM Work."
                                        hide-details
                                    >
                                        <template #prepend-inner>
                                            <span style="padding: 5px 15px 0 0;"
                                                >Subject:
                                            </span>
                                        </template>
                                    </v-text-field>
                                </v-list-item>
                            </v-list>

                            <v-divider></v-divider>

                            <v-list>
                                <v-list-item>
                                    <div
                                        style="display: flex;flex: 1;align-items: center;justify-content:space-between;"
                                        v-if="
                                            NewShiftInfo.generalShiftData
                                                .DriverEleosApp == 1
                                        "
                                    >
                                        <p style="margin: 0;padding: 0;">
                                            Sent By: <b>{{ this.username }}</b>
                                        </p>
                                        <v-switch
                                            v-model="attachPDF"
                                            label="Attach PDF"
                                            color="primary"
                                        ></v-switch>
                                    </div>
                                    <div v-else>
                                        <p style="margin: 0;padding: 0;">
                                            Sent By: <b>{{ this.username }}</b>
                                        </p>
                                    </div>
                                </v-list-item>

                                <v-list-item
                                    v-if="
                                        NewShiftInfo.generalShiftData
                                            .DriverEleosApp == 1
                                    "
                                >
                                    <v-list-item-content>
                                        <div v-if="EmailCounter == 0">
                                            <p>
                                                Hi,
                                                <strong>{{
                                                    data[0]['driver']['Name']
                                                }}</strong
                                                >. On behalf of the
                                                <strong
                                                    >UPT Dispatch & Tracking
                                                    team</strong
                                                >, we notify you that the orders
                                                you will be performing today are
                                                now available on your tablet,
                                                dated
                                                <strong
                                                    >{{
                                                        data[0]['shift_header'][
                                                            'Date'
                                                        ]
                                                    }}
                                                    {{
                                                        data[0]['shift_header'][
                                                            'Shift'
                                                        ]
                                                    }}</strong
                                                >.
                                            </p>
                                            <p>
                                                The unit assigned to you is as
                                                follows.
                                            </p>
                                            <p>
                                                <strong>Truck: </strong
                                                >{{ data[0]['truck']['Truck'] }}
                                            </p>
                                            <p>
                                                <strong>Trailer: </strong
                                                >{{
                                                    data[0]['trailer'][
                                                        'Trailer'
                                                    ]
                                                }}
                                            </p>
                                            <p>
                                                <strong
                                                    >Replacement Unit: </strong
                                                >{{
                                                    data[0][
                                                        'ReplacementUnit'
                                                    ] == null
                                                        ? 'not apply'
                                                        : data[0][
                                                              'ReplacementUnit'
                                                          ]
                                                }}
                                            </p>
                                            <p>
                                                If you encounter any issues,
                                                please contact us.
                                            </p>
                                            <p>Thank you and best regards.</p>
                                        </div>
                                        <div v-else>
                                            <p>
                                                Hi,
                                                <strong>{{
                                                    data[0]['driver']['Name']
                                                }}</strong
                                                >. On behalf of the
                                                <strong
                                                    >UPT Dispatch & Tracking
                                                    team</strong
                                                >, we notify you that there has
                                                been an update on one or more
                                                orders scheduled for today
                                                (<strong
                                                    >{{
                                                        data[0]['shift_header'][
                                                            'Date'
                                                        ]
                                                    }}
                                                    {{
                                                        data[0]['shift_header'][
                                                            'Shift'
                                                        ]
                                                    }}</strong
                                                >).
                                            </p>
                                            <div
                                                v-if="
                                                    diffTruck ||
                                                        diffTrailer ||
                                                        diffReplUnit
                                                "
                                            >
                                                <p>
                                                    <strong
                                                        >In addition, there was
                                                        a change in your planned
                                                        unit. Now your unit is
                                                        as follows:</strong
                                                    >
                                                </p>
                                                <p>
                                                    <strong>Truck: </strong
                                                    >{{
                                                        data[0]['truck'][
                                                            'Truck'
                                                        ]
                                                    }}
                                                </p>
                                                <p>
                                                    <strong>Trailer: </strong
                                                    >{{
                                                        data[0]['trailer'][
                                                            'Trailer'
                                                        ]
                                                    }}
                                                </p>
                                                <p>
                                                    <strong
                                                        >Replacement Unit: </strong
                                                    >{{
                                                        data[0][
                                                            'ReplacementUnit'
                                                        ] == null
                                                            ? 'not apply'
                                                            : data[0][
                                                                  'ReplacementUnit'
                                                              ]
                                                    }}
                                                </p>
                                            </div>
                                            <p>
                                                Please review the changes made
                                                on your tablet.
                                            </p>
                                            <p>
                                                If you encounter any issues,
                                                please contact us.
                                            </p>
                                            <p>Thank you and best regards.</p>
                                        </div>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-else>
                                    <v-list-item-content>
                                        <div>
                                            <p><b>Procedure:</b></p>
                                            <ul
                                                style="display: flex;flex-direction: column;gap: 10px;"
                                            >
                                                <li>
                                                    1. Open your dispatch email
                                                    and start work.
                                                </li>
                                                <li>
                                                    2. Have paperwork? Open this
                                                    dispatch email, click on the
                                                    link above, it will open
                                                    your browser.
                                                </li>
                                                <li>
                                                    3. Click on the camera
                                                    button. The picture is taken
                                                    (mobile device only).
                                                </li>
                                                <li>
                                                    4a. Picture is good? Press
                                                    the up-arrow button to
                                                    upload (a success message
                                                    will appear).
                                                </li>
                                                <li>
                                                    4b. Picture is not good
                                                    enough? No problem, click on
                                                    the camera button to retake.
                                                    Then, click the up-arrow
                                                    button and upload it.
                                                </li>
                                                <li>
                                                    5. Have more paperwork?
                                                    Upload your first image,
                                                    then click on the camera
                                                    button again to capture the
                                                    next image and repeat step.
                                                </li>
                                                <li>6. Done.</li>
                                            </ul>
                                        </div>
                                        <div style="margin: 20px 0;">
                                            <p>
                                                <b
                                                    >Please send a message to
                                                    confirm:</b
                                                >
                                            </p>
                                            <ul
                                                style="display: flex;flex-direction: column;gap: 10px;"
                                            >
                                                <li>
                                                    Please advise which Truck
                                                    and Trailer you have.
                                                </li>
                                                <li>
                                                    Please advise that you have
                                                    received this dispatch (text
                                                    here, pdf attached).
                                                </li>
                                            </ul>
                                        </div>
                                        <div>
                                            <p><b>Important Notes:</b></p>
                                            <ul
                                                style="display: flex;flex-direction: column;gap: 10px;"
                                            >
                                                <li>
                                                    Use of Vapor recovery is
                                                    MANDATORY and must be used
                                                    on all deliveries – no
                                                    exceptions.
                                                </li>
                                                <li>
                                                    Manual dips must be taken
                                                    before and after delivering
                                                    – do not use Veeder readings
                                                    form stations.
                                                </li>
                                                <li>
                                                    Do not change the amounts,
                                                    products loaded, or order of
                                                    your work without
                                                    authorization form dispatch
                                                    or your operations Manager.
                                                </li>
                                            </ul>
                                        </div>
                                        <div
                                            style="border-bottom: 1px solid #000;width: 100%;margin: 15px 0;"
                                        ></div>
                                        <div>
                                            <p style="font-size: large;">
                                                <strong
                                                    >{{
                                                        data[0]['driver'][
                                                            'Name'
                                                        ]
                                                    }}
                                                    /
                                                    {{
                                                        data[0]['shift_header'][
                                                            'Date'
                                                        ]
                                                    }}
                                                    {{
                                                        data[0]['shift_header'][
                                                            'Shift'
                                                        ]
                                                    }}
                                                </strong>
                                            </p>
                                            <div>
                                                <p>
                                                    <b>Shift Detail: </b>
                                                    {{ ShiftDetail }}
                                                </p>
                                                <p>
                                                    <b>Truck: </b>
                                                    {{
                                                        data[0]['truck'][
                                                            'Truck'
                                                        ]
                                                    }}
                                                </p>
                                                <p>
                                                    <b>Trailer: </b>
                                                    {{
                                                        data[0]['trailer'][
                                                            'Trailer'
                                                        ]
                                                    }}
                                                </p>
                                                <p
                                                    style="margin: 0;padding: 0;"
                                                >
                                                    <b>Replacement Unit: </b>
                                                    {{
                                                        data[0][
                                                            'ReplacementUnit'
                                                        ] == null
                                                            ? 'not apply'
                                                            : data[0][
                                                                  'ReplacementUnit'
                                                              ]
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                        <div
                                            style="border-bottom: 1px solid #000;width: 100%;margin: 15px 0;"
                                        ></div>
                                        <div
                                            v-for="(ord,
                                            idx) in NewShiftInfo.ordersShiftData"
                                            :key="idx"
                                        >
                                            <p style="font-size: large;">
                                                <b
                                                    >Load
                                                    {{
                                                        ord.generalOrderData
                                                            .LoadNumOrd == null
                                                            ? ord
                                                                  .generalOrderData
                                                                  .LoadNum
                                                            : ord
                                                                  .generalOrderData
                                                                  .LoadNum +
                                                              '.' +
                                                              ord
                                                                  .generalOrderData
                                                                  .LoadNumOrd
                                                    }}
                                                </b>
                                            </p>
                                            <p>
                                                <b>Preloaded: </b
                                                >{{
                                                    ord.generalOrderData
                                                        .OrderStatus ==
                                                    'PRLDISPAT'
                                                        ? 'YES'
                                                        : 'NO'
                                                }}
                                            </p>
                                            <p>
                                                <b>Preload: </b
                                                >{{
                                                    ord.generalOrderData
                                                        .OrderStatus ==
                                                    'PRELOAD'
                                                        ? 'YES'
                                                        : 'NO'
                                                }}
                                            </p>
                                            <p>
                                                <b>Order: </b
                                                >{{
                                                    ord.generalOrderData.OrderID
                                                }}
                                            </p>
                                            <p>
                                                <b>Terminal: </b
                                                >{{
                                                    ord.generalOrderData
                                                        .Terminal
                                                }}
                                            </p>
                                            <p>
                                                <b>Station: </b
                                                >{{
                                                    ord.generalOrderData.Station
                                                }}
                                            </p>
                                            <p>
                                                <b>Station City: </b>
                                                {{
                                                    ord.generalOrderData
                                                        .StationCity == null
                                                        ? 'not apply'
                                                        : ord.generalOrderData
                                                              .StationCity
                                                }}
                                            </p>
                                            <p>
                                                <b>Station Address: </b>
                                                {{
                                                    ord.generalOrderData
                                                        .StationAddress == null
                                                        ? 'not apply'
                                                        : ord.generalOrderData
                                                              .StationAddress
                                                }}
                                            </p>
                                            <p>
                                                <b>Customer: </b>
                                                {{
                                                    ord.generalOrderData
                                                        .Customer == null
                                                        ? 'not apply'
                                                        : ord.generalOrderData
                                                              .Customer
                                                }}
                                            </p>
                                            <p>
                                                <b>Supplier: </b>
                                                {{
                                                    ord.generalOrderData
                                                        .Supplier == null
                                                        ? 'not apply'
                                                        : ord.generalOrderData
                                                              .Supplier
                                                }}
                                            </p>
                                            <p>
                                                <b>Loading Number: </b>
                                                {{
                                                    ord.generalOrderData
                                                        .LoadingNumber == null
                                                        ? 'not apply'
                                                        : ord.generalOrderData
                                                              .LoadingNumber
                                                }}
                                            </p>
                                            <p>
                                                <b>Ship To: </b>
                                                {{
                                                    ord.generalOrderData
                                                        .ShipTo == null
                                                        ? 'not apply'
                                                        : ord.generalOrderData
                                                              .ShipTo
                                                }}
                                            </p>
                                            <p>
                                                <b>Special Instructions: </b>
                                                {{
                                                    ord.generalOrderData
                                                        .SpecialInstructions ==
                                                    null
                                                        ? 'not specified'
                                                        : ord.generalOrderData
                                                              .SpecialInstructions
                                                }}
                                            </p>
                                            <v-data-table
                                                :headers="productInfoHeaders"
                                                :items="ord.orderProductData"
                                                dense
                                                disable-sort
                                                hide-default-footer
                                                :show-first-last-page="false"
                                            ></v-data-table>
                                            <div
                                                style="border-bottom: 1px solid #000;width: 100%;margin: 15px 0;"
                                            ></div>
                                        </div>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                        <v-stepper
                            v-else-if="
                                NewShiftInfo.generalShiftData.DriverEleosApp ==
                                    1
                            "
                            style="width: 800px; padding: 30px;"
                            v-model="e1"
                            vertical
                        >
                            <v-stepper-step :complete="e1 > 1" step="1">
                                First, please specify the reason for the Revise
                            </v-stepper-step>
                            <v-stepper-content step="1">
                                <div style="padding: 0 10px 0;">
                                    <div
                                        style="display: grid;grid-template-columns: repeat(2, 1fr);"
                                    >
                                        <div
                                            color="#fff"
                                            v-for="(cat, i) in reasonsForRevise"
                                            :key="i"
                                        >
                                            <div style="margin-top: 10px;">
                                                <p>
                                                    <b>{{ cat.title }}</b>
                                                </p>
                                                <div
                                                    v-for="r in cat.reasons"
                                                    :key="r.model"
                                                >
                                                    <v-checkbox
                                                        style="margin: 0;padding: 0;"
                                                        v-model="
                                                            models[r.model]
                                                        "
                                                        :label="r.label"
                                                        color="primary"
                                                        hide-details
                                                        dense
                                                        @change="
                                                            verifyOther(r.model)
                                                        "
                                                    ></v-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="IsOther"
                                        style="margin-top: 30px;"
                                    >
                                        <v-textarea
                                            @input="retrieveTextBody($event)"
                                            outlined
                                            no-resize
                                            hide-details
                                            dense
                                            label="Write here another reason"
                                        ></v-textarea>
                                    </div>
                                </div>
                                <div style="padding: 20px 0;">
                                    <v-btn
                                        color="primary"
                                        @click="validateIfThereIsReason"
                                    >
                                        Continue
                                    </v-btn>
                                </div>
                            </v-stepper-content>

                            <v-stepper-step :complete="e1 > 2" step="2">
                                Send the email to the driver
                            </v-stepper-step>
                            <v-stepper-content step="2">
                                <div>
                                    <v-list>
                                        <v-list-item>
                                            <v-list-item-avatar>
                                                <img
                                                    src="../../../../assets/logo.png"
                                                    alt="UPT"
                                                />
                                            </v-list-item-avatar>

                                            <v-list-item-content>
                                                <v-list-item-title
                                                    style="margin-top: 10px;"
                                                    >United Petroleum
                                                    Transport</v-list-item-title
                                                >
                                                <v-list-item-subtitle>
                                                    <v-text-field
                                                        style="padding: 0;"
                                                        v-model="from"
                                                        :rules="[rules.email]"
                                                        hide-details
                                                        :readonly="true"
                                                    ></v-text-field>
                                                </v-list-item-subtitle>
                                            </v-list-item-content>

                                            <v-list-item-action>
                                                <v-btn
                                                    color="#01579b"
                                                    dark
                                                    @click="
                                                        emailConfirm(
                                                            ShiftDetail
                                                        )
                                                    "
                                                >
                                                    <v-icon left
                                                        >mdi-check-circle</v-icon
                                                    >
                                                    Send Mail
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>

                                    <v-divider></v-divider>

                                    <v-list>
                                        <v-list-item>
                                            <v-text-field
                                                style="padding: 0;"
                                                v-model="to"
                                                :rules="[rules.email]"
                                                hide-details
                                                :readonly="true"
                                            >
                                                <template #prepend-inner>
                                                    <span
                                                        style="padding: 5px 50px 0 0;"
                                                        >To:
                                                    </span>
                                                </template>
                                            </v-text-field>
                                        </v-list-item>

                                        <v-list-item>
                                            <v-text-field
                                                style="padding: 0;"
                                                v-model="cc"
                                                placeholder="Example: email1@upt.com;email2@gmail.com;email3@upt.com;"
                                                hide-details
                                            >
                                                <template #prepend-inner>
                                                    <span
                                                        style="padding: 5px 47px 0 0;"
                                                        >CC:
                                                    </span>
                                                </template>
                                            </v-text-field>
                                        </v-list-item>

                                        <v-list-item>
                                            <v-text-field
                                                style="padding: 0;"
                                                v-model="subject"
                                                placeholder="Example: Friday, December 23, 2022 PM Work."
                                                hide-details
                                            >
                                                <template #prepend-inner>
                                                    <span
                                                        style="padding: 5px 15px 0 0;"
                                                        >Subject:
                                                    </span>
                                                </template>
                                            </v-text-field>
                                        </v-list-item>
                                    </v-list>

                                    <v-divider></v-divider>

                                    <v-list>
                                        <v-list-item>
                                            <div
                                                style="display: flex;flex: 1;align-items: center;justify-content:space-between;"
                                                v-if="
                                                    NewShiftInfo
                                                        .generalShiftData
                                                        .DriverEleosApp == 1
                                                "
                                            >
                                                <p
                                                    style="margin: 0;padding: 0;"
                                                >
                                                    Sent By:
                                                    <b>{{ this.username }}</b>
                                                </p>
                                                <v-switch
                                                    v-model="attachPDF"
                                                    label="Attach PDF"
                                                    color="primary"
                                                ></v-switch>
                                            </div>
                                            <div v-else>
                                                <p
                                                    style="margin: 0;padding: 0;"
                                                >
                                                    Sent By:
                                                    <b>{{ this.username }}</b>
                                                </p>
                                            </div>
                                        </v-list-item>

                                        <v-list-item
                                            v-if="
                                                NewShiftInfo.generalShiftData
                                                    .DriverEleosApp == 1
                                            "
                                        >
                                            <v-list-item-content>
                                                <div v-if="EmailCounter == 0">
                                                    <p>
                                                        Hi,
                                                        <strong>{{
                                                            data[0]['driver'][
                                                                'Name'
                                                            ]
                                                        }}</strong
                                                        >. On behalf of the
                                                        <strong
                                                            >UPT Dispatch &
                                                            Tracking
                                                            team</strong
                                                        >, we notify you that
                                                        the orders you will be
                                                        performing today are now
                                                        available on your
                                                        tablet, dated
                                                        <strong
                                                            >{{
                                                                data[0][
                                                                    'shift_header'
                                                                ]['Date']
                                                            }}
                                                            {{
                                                                data[0][
                                                                    'shift_header'
                                                                ]['Shift']
                                                            }}</strong
                                                        >.
                                                    </p>
                                                    <p>
                                                        The unit assigned to you
                                                        is as follows.
                                                    </p>
                                                    <p>
                                                        <strong>Truck: </strong
                                                        >{{
                                                            data[0]['truck'][
                                                                'Truck'
                                                            ]
                                                        }}
                                                    </p>
                                                    <p>
                                                        <strong
                                                            >Trailer: </strong
                                                        >{{
                                                            data[0]['trailer'][
                                                                'Trailer'
                                                            ]
                                                        }}
                                                    </p>
                                                    <p>
                                                        <strong
                                                            >Replacement Unit: </strong
                                                        >{{
                                                            data[0][
                                                                'ReplacementUnit'
                                                            ] == null
                                                                ? 'not apply'
                                                                : data[0][
                                                                      'ReplacementUnit'
                                                                  ]
                                                        }}
                                                    </p>
                                                    <p>
                                                        If you encounter any
                                                        issues, please contact
                                                        us.
                                                    </p>
                                                    <p>
                                                        Thank you and best
                                                        regards.
                                                    </p>
                                                </div>
                                                <div v-else>
                                                    <p>
                                                        Hi,
                                                        <strong>{{
                                                            data[0]['driver'][
                                                                'Name'
                                                            ]
                                                        }}</strong
                                                        >. On behalf of the
                                                        <strong
                                                            >UPT Dispatch &
                                                            Tracking
                                                            team</strong
                                                        >, we notify you that
                                                        there has been an update
                                                        on one or more orders
                                                        scheduled for today
                                                        (<strong
                                                            >{{
                                                                data[0][
                                                                    'shift_header'
                                                                ]['Date']
                                                            }}
                                                            {{
                                                                data[0][
                                                                    'shift_header'
                                                                ]['Shift']
                                                            }}</strong
                                                        >).
                                                    </p>
                                                    <div
                                                        v-if="
                                                            diffTruck ||
                                                                diffTrailer ||
                                                                diffReplUnit
                                                        "
                                                    >
                                                        <p>
                                                            <strong
                                                                >In addition,
                                                                there was a
                                                                change in your
                                                                planned unit.
                                                                Now your unit is
                                                                as
                                                                follows:</strong
                                                            >
                                                        </p>
                                                        <p>
                                                            <strong
                                                                >Truck: </strong
                                                            >{{
                                                                data[0][
                                                                    'truck'
                                                                ]['Truck']
                                                            }}
                                                        </p>
                                                        <p>
                                                            <strong
                                                                >Trailer: </strong
                                                            >{{
                                                                data[0][
                                                                    'trailer'
                                                                ]['Trailer']
                                                            }}
                                                        </p>
                                                        <p>
                                                            <strong
                                                                >Replacement
                                                                Unit: </strong
                                                            >{{
                                                                data[0][
                                                                    'ReplacementUnit'
                                                                ] == null
                                                                    ? 'not apply'
                                                                    : data[0][
                                                                          'ReplacementUnit'
                                                                      ]
                                                            }}
                                                        </p>
                                                    </div>
                                                    <p>
                                                        Please review the
                                                        changes made on your
                                                        tablet.
                                                    </p>
                                                    <p>
                                                        If you encounter any
                                                        issues, please contact
                                                        us.
                                                    </p>
                                                    <p>
                                                        Thank you and best
                                                        regards.
                                                    </p>
                                                </div>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item v-else>
                                            <v-list-item-content>
                                                <div>
                                                    <p><b>Procedure:</b></p>
                                                    <ul
                                                        style="display: flex;flex-direction: column;gap: 10px;"
                                                    >
                                                        <li>
                                                            1. Open your
                                                            dispatch email and
                                                            start work.
                                                        </li>
                                                        <li>
                                                            2. Have paperwork?
                                                            Open this dispatch
                                                            email, click on the
                                                            link above, it will
                                                            open your browser.
                                                        </li>
                                                        <li>
                                                            3. Click on the
                                                            camera button. The
                                                            picture is taken
                                                            (mobile device
                                                            only).
                                                        </li>
                                                        <li>
                                                            4a. Picture is good?
                                                            Press the up-arrow
                                                            button to upload (a
                                                            success message will
                                                            appear).
                                                        </li>
                                                        <li>
                                                            4b. Picture is not
                                                            good enough? No
                                                            problem, click on
                                                            the camera button to
                                                            retake. Then, click
                                                            the up-arrow button
                                                            and upload it.
                                                        </li>
                                                        <li>
                                                            5. Have more
                                                            paperwork? Upload
                                                            your first image,
                                                            then click on the
                                                            camera button again
                                                            to capture the next
                                                            image and repeat
                                                            step.
                                                        </li>
                                                        <li>6. Done.</li>
                                                    </ul>
                                                </div>
                                                <div style="margin: 20px 0;">
                                                    <p>
                                                        <b
                                                            >Please send a
                                                            message to
                                                            confirm:</b
                                                        >
                                                    </p>
                                                    <ul
                                                        style="display: flex;flex-direction: column;gap: 10px;"
                                                    >
                                                        <li>
                                                            Please advise which
                                                            Truck and Trailer
                                                            you have.
                                                        </li>
                                                        <li>
                                                            Please advise that
                                                            you have received
                                                            this dispatch (text
                                                            here, pdf attached).
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div>
                                                    <p>
                                                        <b>Important Notes:</b>
                                                    </p>
                                                    <ul
                                                        style="display: flex;flex-direction: column;gap: 10px;"
                                                    >
                                                        <li>
                                                            Use of Vapor
                                                            recovery is
                                                            MANDATORY and must
                                                            be used on all
                                                            deliveries – no
                                                            exceptions.
                                                        </li>
                                                        <li>
                                                            Manual dips must be
                                                            taken before and
                                                            after delivering –
                                                            do not use Veeder
                                                            readings form
                                                            stations.
                                                        </li>
                                                        <li>
                                                            Do not change the
                                                            amounts, products
                                                            loaded, or order of
                                                            your work without
                                                            authorization form
                                                            dispatch or your
                                                            operations Manager.
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div
                                                    style="border-bottom: 1px solid #000;width: 100%;margin: 15px 0;"
                                                ></div>
                                                <div>
                                                    <p
                                                        style="font-size: large;"
                                                    >
                                                        <strong
                                                            >{{
                                                                data[0][
                                                                    'driver'
                                                                ]['Name']
                                                            }}
                                                            /
                                                            {{
                                                                data[0][
                                                                    'shift_header'
                                                                ]['Date']
                                                            }}
                                                            {{
                                                                data[0][
                                                                    'shift_header'
                                                                ]['Shift']
                                                            }}
                                                        </strong>
                                                    </p>
                                                    <div>
                                                        <p>
                                                            <b
                                                                >Shift Detail:
                                                            </b>
                                                            {{ ShiftDetail }}
                                                        </p>
                                                        <p>
                                                            <b>Truck: </b>
                                                            {{
                                                                data[0][
                                                                    'truck'
                                                                ]['Truck']
                                                            }}
                                                        </p>
                                                        <p>
                                                            <b>Trailer: </b>
                                                            {{
                                                                data[0][
                                                                    'trailer'
                                                                ]['Trailer']
                                                            }}
                                                        </p>
                                                        <p
                                                            style="margin: 0;padding: 0;"
                                                        >
                                                            <b
                                                                >Replacement
                                                                Unit:
                                                            </b>
                                                            {{
                                                                data[0][
                                                                    'ReplacementUnit'
                                                                ] == null
                                                                    ? 'not apply'
                                                                    : data[0][
                                                                          'ReplacementUnit'
                                                                      ]
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    style="border-bottom: 1px solid #000;width: 100%;margin: 15px 0;"
                                                ></div>
                                                <div
                                                    v-for="(ord,
                                                    idx) in NewShiftInfo.ordersShiftData"
                                                    :key="idx"
                                                >
                                                    <p
                                                        style="font-size: large;"
                                                    >
                                                        <b
                                                            >Load
                                                            {{
                                                                ord
                                                                    .generalOrderData
                                                                    .LoadNumOrd ==
                                                                null
                                                                    ? ord
                                                                          .generalOrderData
                                                                          .LoadNum
                                                                    : ord
                                                                          .generalOrderData
                                                                          .LoadNum +
                                                                      '.' +
                                                                      ord
                                                                          .generalOrderData
                                                                          .LoadNumOrd
                                                            }}
                                                        </b>
                                                    </p>
                                                    <p>
                                                        <b>Preloaded: </b
                                                        >{{
                                                            ord.generalOrderData
                                                                .OrderStatus ==
                                                            'PRLDISPAT'
                                                                ? 'YES'
                                                                : 'NO'
                                                        }}
                                                    </p>
                                                    <p>
                                                        <b>Preload: </b
                                                        >{{
                                                            ord.generalOrderData
                                                                .OrderStatus ==
                                                            'PRELOAD'
                                                                ? 'YES'
                                                                : 'NO'
                                                        }}
                                                    </p>
                                                    <p>
                                                        <b>Order: </b
                                                        >{{
                                                            ord.generalOrderData
                                                                .OrderID
                                                        }}
                                                    </p>
                                                    <p>
                                                        <b>Terminal: </b
                                                        >{{
                                                            ord.generalOrderData
                                                                .Terminal
                                                        }}
                                                    </p>
                                                    <p>
                                                        <b>Station: </b
                                                        >{{
                                                            ord.generalOrderData
                                                                .Station
                                                        }}
                                                    </p>
                                                    <p>
                                                        <b>Station City: </b>
                                                        {{
                                                            ord.generalOrderData
                                                                .StationCity ==
                                                            null
                                                                ? 'not apply'
                                                                : ord
                                                                      .generalOrderData
                                                                      .StationCity
                                                        }}
                                                    </p>
                                                    <p>
                                                        <b>Station Address: </b>
                                                        {{
                                                            ord.generalOrderData
                                                                .StationAddress ==
                                                            null
                                                                ? 'not apply'
                                                                : ord
                                                                      .generalOrderData
                                                                      .StationAddress
                                                        }}
                                                    </p>
                                                    <p>
                                                        <b>Customer: </b>
                                                        {{
                                                            ord.generalOrderData
                                                                .Customer ==
                                                            null
                                                                ? 'not apply'
                                                                : ord
                                                                      .generalOrderData
                                                                      .Customer
                                                        }}
                                                    </p>
                                                    <p>
                                                        <b>Supplier: </b>
                                                        {{
                                                            ord.generalOrderData
                                                                .Supplier ==
                                                            null
                                                                ? 'not apply'
                                                                : ord
                                                                      .generalOrderData
                                                                      .Supplier
                                                        }}
                                                    </p>
                                                    <p>
                                                        <b>Loading Number: </b>
                                                        {{
                                                            ord.generalOrderData
                                                                .LoadingNumber ==
                                                            null
                                                                ? 'not apply'
                                                                : ord
                                                                      .generalOrderData
                                                                      .LoadingNumber
                                                        }}
                                                    </p>
                                                    <p>
                                                        <b>Ship To: </b>
                                                        {{
                                                            ord.generalOrderData
                                                                .ShipTo == null
                                                                ? 'not apply'
                                                                : ord
                                                                      .generalOrderData
                                                                      .ShipTo
                                                        }}
                                                    </p>
                                                    <p>
                                                        <b
                                                            >Special
                                                            Instructions:
                                                        </b>
                                                        {{
                                                            ord.generalOrderData
                                                                .SpecialInstructions ==
                                                            null
                                                                ? 'not specified'
                                                                : ord
                                                                      .generalOrderData
                                                                      .SpecialInstructions
                                                        }}
                                                    </p>
                                                    <v-data-table
                                                        :headers="
                                                            productInfoHeaders
                                                        "
                                                        :items="
                                                            ord.orderProductData
                                                        "
                                                        dense
                                                        disable-sort
                                                        hide-default-footer
                                                        :show-first-last-page="
                                                            false
                                                        "
                                                    ></v-data-table>
                                                    <div
                                                        style="border-bottom: 1px solid #000;width: 100%;margin: 15px 0;"
                                                    ></div>
                                                </div>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </div>
                            </v-stepper-content>
                        </v-stepper>
                    </v-menu>
                </v-col>
                <v-toolbar-title class="white--text"
                    >Shift Summary</v-toolbar-title
                >
                <v-col style="margin: 0px 6px;padding: 0px 6px;">
                    <v-btn
                        text
                        class="float-right"
                        tile
                        dark
                        @click="$store.state.dispatch.shiftSummary = false"
                    >
                        <v-icon left>mdi-arrow-left</v-icon> Go Back
                    </v-btn>
                </v-col>
            </v-toolbar>
            <div
                v-if="
                    EmailCounter == 0 ||
                        NewShiftInfo.generalShiftData.DriverEleosApp != 1
                "
                class="panels-container"
            >
                <v-card
                    elevation="2"
                    style="margin-bottom: 20px;padding-left: 16px;"
                >
                    <v-card-title
                        >{{ NewShiftInfo.generalShiftData.Driver }} /
                        {{ NewShiftInfo.generalShiftData.ShiftDate }}
                        {{ NewShiftInfo.generalShiftData.Shift }}
                    </v-card-title>
                    <v-card-text>
                        <p style="margin: 5px 0;font-size: medium;">
                            <b>Shift Detail:</b>
                            {{ NewShiftInfo.generalShiftData.ShiftDetail }}
                        </p>
                        <p style="margin: 5px 0;font-size: medium;">
                            <b>Truck:</b>
                            {{ NewShiftInfo.generalShiftData.Truck }}
                        </p>
                        <p style="margin: 5px 0;font-size: medium;">
                            <b>Trailer:</b>
                            {{ NewShiftInfo.generalShiftData.Trailer }}
                        </p>
                        <p style="margin: 5px 0;font-size: medium;">
                            <b>Replacement Unit:</b>
                            {{
                                NewShiftInfo.generalShiftData.ReplacementUnit ==
                                null
                                    ? 'not apply'
                                    : NewShiftInfo.generalShiftData
                                          .ReplacementUnit
                            }}
                        </p>
                    </v-card-text>
                </v-card>
                <v-expansion-panels focusable hover>
                    <v-expansion-panel
                        v-for="(item, i) in NewShiftInfo.ordersShiftData"
                        :key="i"
                        style="background-color: #4f83cc;"
                    >
                        <v-expansion-panel-header
                            style="color: #fff;text-align: center;font-size: medium;"
                        >
                            <div
                                style="display: grid;grid-template-columns: repeat(2, 1fr);padding-left: 8px;"
                            >
                                <p style="margin: 0;text-align: left;">
                                    Order {{ item.generalOrderData.OrderID }}
                                </p>
                                <p
                                    style="margin: 0 20px 0 0;text-align: right;"
                                >
                                    Load {{ item.generalOrderData.LoadNum }}
                                    <span
                                        v-if="
                                            item.generalOrderData.LoadNumOrd !=
                                                null
                                        "
                                        >.
                                        {{
                                            item.generalOrderData.LoadNumOrd
                                        }}</span
                                    >
                                </p>
                            </div>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content
                            style="background-color: #fff;padding-left: 16px;"
                        >
                            <p
                                style="margin: 20px 0;font-size: x-large;color: #01579b;font-weight: 500;"
                            >
                                Order Info
                            </p>
                            <p style="margin: 20px 0 5px;font-size: medium;">
                                <b>Preloaded:</b>
                                {{
                                    item.generalOrderData.OrderStatus ==
                                    'PRLDISPAT'
                                        ? 'YES'
                                        : 'NO'
                                }}
                            </p>
                            <p style="margin: 5px 0;font-size: medium;">
                                <b>Preload:</b>
                                {{
                                    item.generalOrderData.OrderStatus ==
                                    'PRELOAD'
                                        ? 'YES'
                                        : 'NO'
                                }}
                            </p>
                            <p style="margin: 5px 0;font-size: medium;">
                                <b>Terminal:</b>
                                {{ item.generalOrderData.Terminal }}
                            </p>
                            <p style="margin: 5px 0;font-size: medium;">
                                <b>Station:</b>
                                {{ item.generalOrderData.Station }}
                            </p>
                            <p style="margin: 5px 0;font-size: medium;">
                                <b>Station Address:</b>
                                {{ item.generalOrderData.StationAddress }}
                            </p>
                            <p style="margin: 5px 0;font-size: medium;">
                                <b>Station City:</b>
                                {{ item.generalOrderData.StationCity }}
                            </p>
                            <p style="margin: 5px 0;font-size: medium;">
                                <b>Customer:</b>
                                {{ item.generalOrderData.Customer }}
                            </p>
                            <p style="margin: 5px 0;font-size: medium;">
                                <b>Supplier:</b>
                                {{ item.generalOrderData.Supplier }}
                            </p>
                            <p style="margin: 5px 0;font-size: medium;">
                                <b>Loading Number:</b>
                                {{ item.generalOrderData.LoadingNumber }}
                            </p>
                            <p style="margin: 5px 0;font-size: medium;">
                                <b>Ship To:</b>
                                {{
                                    item.generalOrderData.ShipTo == null
                                        ? 'not apply'
                                        : item.generalOrderData.ShipTo
                                }}
                            </p>
                            <p style="margin: 5px 0 20px;font-size: medium;">
                                <b>Special Instructions:</b>
                                {{
                                    item.generalOrderData.SpecialInstructions ==
                                    null
                                        ? 'not specified'
                                        : item.generalOrderData
                                              .SpecialInstructions
                                }}
                            </p>
                            <v-divider></v-divider>
                            <p
                                style="margin: 20px 0;font-size: x-large;color: #01579b;font-weight: 500;"
                            >
                                Product Info
                            </p>
                            <div v-if="readyProducts">
                                <div
                                    v-for="(prd, idx) in item.orderProductData"
                                    :key="idx"
                                >
                                    <p
                                        style="margin: 20px 0 5px;font-size: medium;"
                                    >
                                        <b>Product:</b> {{ prd.Product }}
                                    </p>
                                    <p style="margin: 5px 0;font-size: medium;">
                                        <b>Product Code:</b>
                                        {{ prd.ProductCode }}
                                    </p>
                                    <p
                                        style="margin: 5px 0 20px;font-size: medium;"
                                    >
                                        <b>Dispatched Quantity:</b>
                                        {{ prd.DispatchedQuantity }}
                                    </p>
                                    <v-divider></v-divider>
                                </div>
                            </div>
                            <div v-else style="min-height: 4px;">
                                <v-progress-linear
                                    v-model="value"
                                    :active="show"
                                    :indeterminate="query"
                                    :query="true"
                                ></v-progress-linear>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <div
                v-else-if="NewShiftInfo.generalShiftData.DriverEleosApp == 1"
                class="panels-container"
            >
                <v-card
                    elevation="2"
                    style="margin-bottom: 20px;padding: 0 32px 0 16px;"
                >
                    <v-card-title style="padding: 16px 0 5px 16px;"
                        >{{ NewShiftInfo.generalShiftData.Driver }} /
                        {{ NewShiftInfo.generalShiftData.ShiftDate }}
                        {{ NewShiftInfo.generalShiftData.Shift }}
                    </v-card-title>
                    <p style="margin: 0 0 0 16px;font-size: medium;">
                        <b>Shift Detail:</b>
                        {{ NewShiftInfo.generalShiftData.ShiftDetail }}
                    </p>
                    <div
                        style="display: grid;grid-template-columns: repeat(2, 1fr);margin-top: 15px;"
                    >
                        <v-card-text>
                            <p
                                style="font-size: xx-large;margin-bottom: 35px;text-align: center;"
                            >
                                Current
                            </p>
                            <v-divider></v-divider>
                            <p
                                style="margin: 25px 0 0;font-size: medium;padding-left: 5px;"
                                v-bind:class="diffTruck ? 'diff-current' : ''"
                            >
                                <b>Truck:</b>
                                {{ currentShiftInfo.generalShiftData.Truck }}
                            </p>
                            <p
                                style="margin: 5px 0;font-size: medium;padding-left: 5px;"
                                v-bind:class="diffTrailer ? 'diff-current' : ''"
                            >
                                <b>Trailer:</b>
                                {{ currentShiftInfo.generalShiftData.Trailer }}
                            </p>
                            <p
                                style="margin: 5px 0;font-size: medium;padding-left: 5px;"
                                v-bind:class="
                                    diffReplUnit ? 'diff-current' : ''
                                "
                            >
                                <b>Replacement Unit:</b>
                                {{
                                    currentShiftInfo.generalShiftData
                                        .ReplacementUnit == null
                                        ? 'not apply'
                                        : currentShiftInfo.generalShiftData
                                              .ReplacementUnit
                                }}
                            </p>
                        </v-card-text>
                        <v-card-text class="">
                            <p
                                style="font-size: xx-large;margin-bottom: 35px;text-align: center;"
                            >
                                New
                            </p>
                            <v-divider></v-divider>
                            <p
                                style="margin: 25px 0 0;font-size: medium;padding-left: 5px;"
                                v-bind:class="diffTruck ? 'diff-new' : ''"
                            >
                                <b>Truck:</b>
                                {{ NewShiftInfo.generalShiftData.Truck }}
                            </p>
                            <p
                                style="margin: 5px 0;font-size: medium;padding-left: 5px;"
                                v-bind:class="diffTrailer ? 'diff-new' : ''"
                            >
                                <b>Trailer:</b>
                                {{ NewShiftInfo.generalShiftData.Trailer }}
                            </p>
                            <p
                                style="margin: 5px 0;font-size: medium;padding-left: 5px;"
                                v-bind:class="diffReplUnit ? 'diff-new' : ''"
                            >
                                <b>Replacement Unit:</b>
                                {{
                                    NewShiftInfo.generalShiftData
                                        .ReplacementUnit == null
                                        ? 'not apply'
                                        : NewShiftInfo.generalShiftData
                                              .ReplacementUnit
                                }}
                            </p>
                        </v-card-text>
                    </div>
                </v-card>
                <div v-if="orderDataReady">
                    <v-expansion-panels focusable hover>
                        <v-expansion-panel
                            v-for="(item, i) in OrderData"
                            :key="i"
                            v-bind:style="
                                item.New == false
                                    ? 'background-color: #EC5D5D;'
                                    : item.Current == false
                                    ? 'background-color: #5ED291;'
                                    : 'background-color: #4f83cc;'
                            "
                        >
                            <div v-if="item.New == false">
                                <v-expansion-panel-header
                                    style="color: #fff;font-size: medium;"
                                >
                                    <div
                                        style="display: grid;grid-template-columns: repeat(2, 1fr);"
                                    >
                                        <p
                                            style="margin: 0;text-align: center;"
                                        >
                                            Order
                                            {{
                                                item.Current.generalOrderData
                                                    .OrderID
                                            }}
                                            /
                                            <span>
                                                Load
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .LoadNum
                                                }}
                                                <span
                                                    v-if="
                                                        item.Current
                                                            .generalOrderData
                                                            .LoadNumOrd != null
                                                    "
                                                    >.
                                                    {{
                                                        item.Current
                                                            .generalOrderData
                                                            .LoadNumOrd
                                                    }}</span
                                                >
                                            </span>
                                        </p>
                                        <p
                                            style="margin: 0;text-align: center;"
                                        >
                                            <span></span>
                                        </p>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content
                                    style="background-color: #fff;"
                                >
                                    <div style="padding-left: 8px;">
                                        <p
                                            style="margin: 20px 0;font-size: x-large;color: #01579b;font-weight: 500;"
                                        >
                                            Order Info
                                        </p>
                                        <p
                                            style="margin: 20px 0 5px;font-size: medium;"
                                        >
                                            <b>Preloaded:</b>
                                            {{
                                                item.Current.generalOrderData
                                                    .OrderStatus == 'PRLDISPAT'
                                                    ? 'YES'
                                                    : 'NO'
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Preload:</b>
                                            {{
                                                item.Current.generalOrderData
                                                    .OrderStatus == 'PRELOAD'
                                                    ? 'YES'
                                                    : 'NO'
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Terminal:</b>
                                            {{
                                                item.Current.generalOrderData
                                                    .Terminal
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Station:</b>
                                            {{
                                                item.Current.generalOrderData
                                                    .Station
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Station Address:</b>
                                            {{
                                                item.Current.generalOrderData
                                                    .StationAddress
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Station City:</b>
                                            {{
                                                item.Current.generalOrderData
                                                    .StationCity
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Customer:</b>
                                            {{
                                                item.Current.generalOrderData
                                                    .Customer
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Supplier:</b>
                                            {{
                                                item.Current.generalOrderData
                                                    .Supplier
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Loading Number:</b>
                                            {{
                                                item.Current.generalOrderData
                                                    .LoadingNumber
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Ship To:</b>
                                            {{
                                                item.Current.generalOrderData
                                                    .ShipTo == null
                                                    ? 'not apply'
                                                    : item.Current
                                                          .generalOrderData
                                                          .ShipTo
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0 20px;font-size: medium;"
                                        >
                                            <b>Special Instructions:</b>
                                            {{
                                                item.Current.generalOrderData
                                                    .SpecialInstructions == null
                                                    ? 'not specified'
                                                    : item.Current
                                                          .generalOrderData
                                                          .SpecialInstructions
                                            }}
                                        </p>
                                        <v-divider></v-divider>
                                        <p
                                            style="margin: 20px 0;font-size: x-large;color: #01579b;font-weight: 500;"
                                        >
                                            Product Info
                                        </p>
                                        <div v-if="readyProducts">
                                            <div
                                                v-for="(prd, idx) in item
                                                    .Current.orderProductData"
                                                :key="idx"
                                            >
                                                <p
                                                    style="margin: 20px 0 5px;font-size: medium;"
                                                >
                                                    <b>Product:</b>
                                                    {{ prd.Product }}
                                                </p>
                                                <p
                                                    style="margin: 5px 0;font-size: medium;"
                                                >
                                                    <b>Product Code:</b>
                                                    {{ prd.ProductCode }}
                                                </p>
                                                <p
                                                    style="margin: 5px 0 20px;font-size: medium;"
                                                >
                                                    <b>Dispatched Quantity:</b>
                                                    {{ prd.DispatchedQuantity }}
                                                </p>
                                                <v-divider></v-divider>
                                            </div>
                                        </div>
                                        <div v-else style="min-height: 4px;">
                                            <v-progress-linear
                                                v-model="value"
                                                :active="show"
                                                :indeterminate="query"
                                                :query="true"
                                            ></v-progress-linear>
                                        </div>
                                    </div>
                                </v-expansion-panel-content>
                            </div>

                            <div v-else-if="item.Current == false">
                                <v-expansion-panel-header
                                    style="color: #fff;font-size: medium;"
                                >
                                    <div
                                        style="display: grid;grid-template-columns: repeat(2, 1fr);"
                                    >
                                        <p
                                            style="margin: 0;text-align: center;"
                                        >
                                            Order
                                            {{
                                                item.New.generalOrderData
                                                    .OrderID
                                            }}
                                            /
                                            <span>
                                                Load
                                                {{
                                                    item.New.generalOrderData
                                                        .LoadNum
                                                }}
                                                <span
                                                    v-if="
                                                        item.New
                                                            .generalOrderData
                                                            .LoadNumOrd != null
                                                    "
                                                    >.
                                                    {{
                                                        item.New
                                                            .generalOrderData
                                                            .LoadNumOrd
                                                    }}</span
                                                >
                                            </span>
                                        </p>
                                        <p
                                            style="margin: 0;text-align: center;"
                                        >
                                            <span></span>
                                        </p>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content
                                    style="background-color: #fff;"
                                >
                                    <div style="padding-left: 8px;">
                                        <p
                                            style="margin: 20px 0;font-size: x-large;color: #01579b;font-weight: 500;"
                                        >
                                            Order Info
                                        </p>
                                        <p
                                            style="margin: 20px 0 5px;font-size: medium;"
                                        >
                                            <b>Preloaded:</b>
                                            {{
                                                item.New.generalOrderData
                                                    .OrderStatus == 'PRLDISPAT'
                                                    ? 'YES'
                                                    : 'NO'
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Preload:</b>
                                            {{
                                                item.New.generalOrderData
                                                    .OrderStatus == 'PRELOAD'
                                                    ? 'YES'
                                                    : 'NO'
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Terminal:</b>
                                            {{
                                                item.New.generalOrderData
                                                    .Terminal
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Station:</b>
                                            {{
                                                item.New.generalOrderData
                                                    .Station
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Station Address:</b>
                                            {{
                                                item.New.generalOrderData
                                                    .StationAddress
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Station City:</b>
                                            {{
                                                item.New.generalOrderData
                                                    .StationCity
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Customer:</b>
                                            {{
                                                item.New.generalOrderData
                                                    .Customer
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Supplier:</b>
                                            {{
                                                item.New.generalOrderData
                                                    .Supplier
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Loading Number:</b>
                                            {{
                                                item.New.generalOrderData
                                                    .LoadingNumber
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0;font-size: medium;"
                                        >
                                            <b>Ship To:</b>
                                            {{
                                                item.New.generalOrderData
                                                    .ShipTo == null
                                                    ? 'not apply'
                                                    : item.New.generalOrderData
                                                          .ShipTo
                                            }}
                                        </p>
                                        <p
                                            style="margin: 5px 0 20px;font-size: medium;"
                                        >
                                            <b>Special Instructions:</b>
                                            {{
                                                item.New.generalOrderData
                                                    .SpecialInstructions == null
                                                    ? 'not specified'
                                                    : item.New.generalOrderData
                                                          .SpecialInstructions
                                            }}
                                        </p>
                                        <v-divider></v-divider>
                                        <p
                                            style="margin: 20px 0;font-size: x-large;color: #01579b;font-weight: 500;"
                                        >
                                            Product Info
                                        </p>
                                        <div v-if="readyProducts">
                                            <div
                                                v-for="(prd, idx) in item.New
                                                    .orderProductData"
                                                :key="idx"
                                            >
                                                <p
                                                    style="margin: 20px 0 5px;font-size: medium;"
                                                >
                                                    <b>Product:</b>
                                                    {{ prd.Product }}
                                                </p>
                                                <p
                                                    style="margin: 5px 0;font-size: medium;"
                                                >
                                                    <b>Product Code:</b>
                                                    {{ prd.ProductCode }}
                                                </p>
                                                <p
                                                    style="margin: 5px 0 20px;font-size: medium;"
                                                >
                                                    <b>Dispatched Quantity:</b>
                                                    {{ prd.DispatchedQuantity }}
                                                </p>
                                                <v-divider></v-divider>
                                            </div>
                                        </div>
                                        <div v-else style="min-height: 4px;">
                                            <v-progress-linear
                                                v-model="value"
                                                :active="show"
                                                :indeterminate="query"
                                                :query="true"
                                            ></v-progress-linear>
                                        </div>
                                    </div>
                                </v-expansion-panel-content>
                            </div>

                            <div v-else>
                                <v-expansion-panel-header
                                    style="color: #fff;font-size: medium;"
                                >
                                    <div
                                        v-if="
                                            item.New.generalOrderData.orderDiffs
                                                .hasDiffs ||
                                                item.New.generalOrderData
                                                    .orderDiffs.hasPrdDiffs
                                        "
                                        style="display: grid;grid-template-columns: 0px auto auto;align-items: center;"
                                    >
                                        <v-icon color="yellow darken-2">
                                            mdi-alert-circle
                                        </v-icon>
                                        <p
                                            style="margin: 0;text-align: center;"
                                        >
                                            Order
                                            {{
                                                item.Current.generalOrderData
                                                    .OrderID
                                            }}
                                            /
                                            <span
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffLoadNum
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                Load
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .LoadNum
                                                }}
                                                <span
                                                    v-if="
                                                        item.Current
                                                            .generalOrderData
                                                            .LoadNumOrd != null
                                                    "
                                                    v-bind:class="
                                                        item.New
                                                            .generalOrderData
                                                            .orderDiffs
                                                            .diffLoadNumOrd
                                                            ? 'diff-current'
                                                            : ''
                                                    "
                                                    >.
                                                    {{
                                                        item.Current
                                                            .generalOrderData
                                                            .LoadNumOrd
                                                    }}</span
                                                >
                                            </span>
                                        </p>
                                        <p
                                            style="margin: 0;text-align: center;"
                                        >
                                            Order
                                            {{
                                                item.New.generalOrderData
                                                    .OrderID
                                            }}
                                            /
                                            <span
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffLoadNum
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                Load
                                                {{
                                                    item.New.generalOrderData
                                                        .LoadNum
                                                }}
                                                <span
                                                    v-if="
                                                        item.New
                                                            .generalOrderData
                                                            .LoadNumOrd != null
                                                    "
                                                    v-bind:class="
                                                        item.New
                                                            .generalOrderData
                                                            .orderDiffs
                                                            .diffLoadNumOrd
                                                            ? 'diff-new'
                                                            : ''
                                                    "
                                                    >.
                                                    {{
                                                        item.New
                                                            .generalOrderData
                                                            .LoadNumOrd
                                                    }}</span
                                                >
                                            </span>
                                        </p>
                                    </div>
                                    <div
                                        v-else
                                        style="display: grid;grid-template-columns: repeat(2, 1fr);"
                                    >
                                        <p
                                            style="margin: 0;text-align: center;"
                                        >
                                            Order
                                            {{
                                                item.Current.generalOrderData
                                                    .OrderID
                                            }}
                                            /
                                            <span
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffLoadNum
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                Load
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .LoadNum
                                                }}
                                                <span
                                                    v-if="
                                                        item.Current
                                                            .generalOrderData
                                                            .LoadNumOrd != null
                                                    "
                                                    v-bind:class="
                                                        item.New
                                                            .generalOrderData
                                                            .orderDiffs
                                                            .diffLoadNumOrd
                                                            ? 'diff-current'
                                                            : ''
                                                    "
                                                    >.
                                                    {{
                                                        item.Current
                                                            .generalOrderData
                                                            .LoadNumOrd
                                                    }}</span
                                                >
                                            </span>
                                        </p>
                                        <p
                                            style="margin: 0;text-align: center;"
                                        >
                                            Order
                                            {{
                                                item.New.generalOrderData
                                                    .OrderID
                                            }}
                                            /
                                            <span
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffLoadNum
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                Load
                                                {{
                                                    item.New.generalOrderData
                                                        .LoadNum
                                                }}
                                                <span
                                                    v-if="
                                                        item.New
                                                            .generalOrderData
                                                            .LoadNumOrd != null
                                                    "
                                                    v-bind:class="
                                                        item.New
                                                            .generalOrderData
                                                            .orderDiffs
                                                            .diffLoadNumOrd
                                                            ? 'diff-new'
                                                            : ''
                                                    "
                                                    >.
                                                    {{
                                                        item.New
                                                            .generalOrderData
                                                            .LoadNumOrd
                                                    }}</span
                                                >
                                            </span>
                                        </p>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content
                                    style="background-color: #fff;"
                                >
                                    <div
                                        style="display: grid;grid-template-columns: repeat(2, 1fr);gap: 50px;padding: 0 32px 0 16px;"
                                    >
                                        <div>
                                            <p
                                                style="margin: 20px 0;font-size: x-large;color: #01579b;font-weight: 500;"
                                            >
                                                Order Info
                                            </p>
                                            <p
                                                style="margin: 20px 0 5px;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs
                                                        .diffPreloaded
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                <b>Preloaded:</b>
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .OrderStatus ==
                                                    'PRLDISPAT'
                                                        ? 'YES'
                                                        : 'NO'
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs
                                                        .diffPreloaded
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                <b>Preload:</b>
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .OrderStatus ==
                                                    'PRELOAD'
                                                        ? 'YES'
                                                        : 'NO'
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffTerminal
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                <b>Terminal:</b>
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .Terminal
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffStation
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                <b>Station:</b>
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .Station
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffStation
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                <b>Station Address:</b>
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .StationAddress
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffStation
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                <b>Station City:</b>
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .StationCity
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffCustomer
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                <b>Customer:</b>
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .Customer
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffSupplier
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                <b>Supplier:</b>
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .Supplier
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs
                                                        .diffLoadingNumber
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                <b>Loading Number:</b>
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .LoadingNumber
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffShipTo
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                <b>Ship To:</b>
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .ShipTo == null
                                                        ? 'not apply'
                                                        : item.Current
                                                              .generalOrderData
                                                              .ShipTo
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0 20px;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs
                                                        .diffSpecialInstructions
                                                        ? 'diff-current'
                                                        : ''
                                                "
                                            >
                                                <b>Special Instructions:</b>
                                                {{
                                                    item.Current
                                                        .generalOrderData
                                                        .SpecialInstructions ==
                                                    null
                                                        ? 'not specified'
                                                        : item.Current
                                                              .generalOrderData
                                                              .SpecialInstructions
                                                }}
                                            </p>
                                            <v-divider></v-divider>
                                            <p
                                                style="margin: 20px 0;font-size: x-large;color: #01579b;font-weight: 500;"
                                            >
                                                Product Info
                                            </p>
                                            <div v-if="readyProducts">
                                                <div
                                                    v-for="(prd, idx) in item
                                                        .New
                                                        .MatchingProductData"
                                                    :key="idx"
                                                >
                                                    <p
                                                        style="margin: 20px 0 5px;font-size: medium;"
                                                    >
                                                        <b>Product:</b>
                                                        {{
                                                            prd.Current.Product
                                                        }}
                                                    </p>
                                                    <p
                                                        style="margin: 5px 0;font-size: medium;"
                                                    >
                                                        <b>Product Code:</b>
                                                        {{
                                                            prd.Current
                                                                .ProductCode
                                                        }}
                                                    </p>
                                                    <p
                                                        style="margin: 5px 0 20px;font-size: medium;"
                                                        v-bind:class="
                                                            prd.New
                                                                .diffDispatchedQuantity
                                                                ? 'diff-current'
                                                                : ''
                                                        "
                                                    >
                                                        <b
                                                            >Dispatched
                                                            Quantity:</b
                                                        >
                                                        {{
                                                            prd.Current
                                                                .DispatchedQuantity
                                                        }}
                                                    </p>
                                                    <v-divider></v-divider>
                                                </div>
                                                <div
                                                    style="border: 2px #EC5D5D solid;border-radius: 5px;padding: 5px;margin-top: 20px;"
                                                    v-if="
                                                        item.New
                                                            .OnlyCurrentProductData
                                                            .length > 0
                                                    "
                                                >
                                                    <div
                                                        v-for="(prd,
                                                        idx) in item.New
                                                            .OnlyCurrentProductData"
                                                        :key="idx"
                                                        style="padding: 10px;"
                                                    >
                                                        <p
                                                            style="margin: 0 0 5px;font-size: medium;"
                                                        >
                                                            <b>Product:</b>
                                                            {{ prd.Product }}
                                                        </p>
                                                        <p
                                                            style="margin: 5px 0;font-size: medium;"
                                                        >
                                                            <b>Product Code:</b>
                                                            {{
                                                                prd.ProductCode
                                                            }}
                                                        </p>
                                                        <p
                                                            style="margin: 5px 0 15px;font-size: medium;"
                                                        >
                                                            <b
                                                                >Dispatched
                                                                Quantity:</b
                                                            >
                                                            {{
                                                                prd.DispatchedQuantity
                                                            }}
                                                        </p>
                                                        <v-divider></v-divider>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                v-else
                                                style="min-height: 4px;"
                                            >
                                                <v-progress-linear
                                                    v-model="value"
                                                    :active="show"
                                                    :indeterminate="query"
                                                    :query="true"
                                                ></v-progress-linear>
                                            </div>
                                        </div>
                                        <div>
                                            <p
                                                style="margin: 20px 0;font-size: x-large;color: #01579b;font-weight: 500;"
                                            >
                                                Order Info
                                            </p>
                                            <p
                                                style="margin: 20px 0 5px;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs
                                                        .diffPreloaded
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                <b>Preloaded:</b>
                                                {{
                                                    item.New.generalOrderData
                                                        .OrderStatus ==
                                                    'PRLDISPAT'
                                                        ? 'YES'
                                                        : 'NO'
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs
                                                        .diffPreloaded
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                <b>Preload:</b>
                                                {{
                                                    item.New.generalOrderData
                                                        .OrderStatus ==
                                                    'PRELOAD'
                                                        ? 'YES'
                                                        : 'NO'
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffTerminal
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                <b>Terminal:</b>
                                                {{
                                                    item.New.generalOrderData
                                                        .Terminal
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffStation
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                <b>Station:</b>
                                                {{
                                                    item.New.generalOrderData
                                                        .Station
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffStation
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                <b>Station Address:</b>
                                                {{
                                                    item.New.generalOrderData
                                                        .StationAddress
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffStation
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                <b>Station City:</b>
                                                {{
                                                    item.New.generalOrderData
                                                        .StationCity
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffCustomer
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                <b>Customer:</b>
                                                {{
                                                    item.New.generalOrderData
                                                        .Customer
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffSupplier
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                <b>Supplier:</b>
                                                {{
                                                    item.New.generalOrderData
                                                        .Supplier
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs
                                                        .diffLoadingNumber
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                <b>Loading Number:</b>
                                                {{
                                                    item.New.generalOrderData
                                                        .LoadingNumber
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs.diffShipTo
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                <b>Ship To:</b>
                                                {{
                                                    item.New.generalOrderData
                                                        .ShipTo == null
                                                        ? 'not apply'
                                                        : item.New
                                                              .generalOrderData
                                                              .ShipTo
                                                }}
                                            </p>
                                            <p
                                                style="margin: 5px 0 20px;font-size: medium;"
                                                v-bind:class="
                                                    item.New.generalOrderData
                                                        .orderDiffs
                                                        .diffSpecialInstructions
                                                        ? 'diff-new'
                                                        : ''
                                                "
                                            >
                                                <b>Special Instructions:</b>
                                                {{
                                                    item.New.generalOrderData
                                                        .SpecialInstructions ==
                                                    null
                                                        ? 'not specified'
                                                        : item.New
                                                              .generalOrderData
                                                              .SpecialInstructions
                                                }}
                                            </p>
                                            <v-divider></v-divider>
                                            <p
                                                style="margin: 20px 0;font-size: x-large;color: #01579b;font-weight: 500;"
                                            >
                                                Product Info
                                            </p>
                                            <div v-if="readyProducts">
                                                <div
                                                    v-for="(prd, idx) in item
                                                        .New
                                                        .MatchingProductData"
                                                    :key="idx"
                                                >
                                                    <p
                                                        style="margin: 20px 0 5px;font-size: medium;"
                                                    >
                                                        <b>Product:</b>
                                                        {{ prd.New.Product }}
                                                    </p>
                                                    <p
                                                        style="margin: 5px 0;font-size: medium;"
                                                    >
                                                        <b>Product Code:</b>
                                                        {{
                                                            prd.New.ProductCode
                                                        }}
                                                    </p>
                                                    <p
                                                        style="margin: 5px 0 20px;font-size: medium;"
                                                        v-bind:class="
                                                            prd.New
                                                                .diffDispatchedQuantity
                                                                ? 'diff-new'
                                                                : ''
                                                        "
                                                    >
                                                        <b
                                                            >Dispatched
                                                            Quantity:</b
                                                        >
                                                        {{
                                                            prd.New
                                                                .DispatchedQuantity
                                                        }}
                                                    </p>
                                                    <v-divider></v-divider>
                                                </div>
                                                <div
                                                    style="border: 2px #5ED291 solid;border-radius: 5px;padding: 5px;margin-top: 20px;"
                                                    v-if="
                                                        item.New
                                                            .OnlyNewProductData
                                                            .length > 0
                                                    "
                                                >
                                                    <div
                                                        v-for="(prd,
                                                        idx) in item.New
                                                            .OnlyNewProductData"
                                                        :key="idx"
                                                        style="padding: 10px;"
                                                    >
                                                        <p
                                                            style="margin: 0 0 5px;font-size: medium;"
                                                        >
                                                            <b>Product:</b>
                                                            {{ prd.Product }}
                                                        </p>
                                                        <p
                                                            style="margin: 5px 0;font-size: medium;"
                                                        >
                                                            <b>Product Code:</b>
                                                            {{
                                                                prd.ProductCode
                                                            }}
                                                        </p>
                                                        <p
                                                            style="margin: 5px 0 15px;font-size: medium;"
                                                        >
                                                            <b
                                                                >Dispatched
                                                                Quantity:</b
                                                            >
                                                            {{
                                                                prd.DispatchedQuantity
                                                            }}
                                                        </p>
                                                        <v-divider></v-divider>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                v-else
                                                style="min-height: 4px;"
                                            >
                                                <v-progress-linear
                                                    v-model="value"
                                                    :active="show"
                                                    :indeterminate="query"
                                                    :query="true"
                                                ></v-progress-linear>
                                            </div>
                                        </div>
                                    </div>
                                </v-expansion-panel-content>
                            </div>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
                <div v-else>
                    <v-progress-linear
                        indeterminate
                        color="blue darken-2"
                    ></v-progress-linear>
                    <br />
                    <v-progress-linear
                        indeterminate
                        color="blue darken-2"
                    ></v-progress-linear>
                    <br />
                    <v-progress-linear
                        indeterminate
                        color="blue darken-2"
                    ></v-progress-linear>
                    <br />
                    <v-progress-linear
                        indeterminate
                        color="blue darken-2"
                    ></v-progress-linear>
                </div>
            </div>
        </v-card>

        <ProcessVerifier
            v-if="$store.state.dispatch.processVerifier"
            :MailingReady="mailingReady"
            :LoadsReady="loadsReady"
            :EmailCounterReference="emailCounterReference"
            :DvrEleosApp="NewShiftInfo.generalShiftData.DriverEleosApp"
        ></ProcessVerifier>
    </v-dialog>
</template>
<script>
import moment from 'moment';
import axios from 'axios';
import ProcessVerifier from './ProcessVerifier.vue';
export default {
    props: ['ShiftDetail', 'EmailCounter', 'NewShiftInfo'],
    components: {
        ProcessVerifier
    },
    data: function() {
        return {
            OrderData: [],
            currentShiftInfo: {},
            username: '',
            from: 'dispatch@upt.ca',
            to: '',
            cc: '',
            subject: '',
            email: '',
            data: [
                {
                    shift_header: {
                        Date: '',
                        Shift: ''
                    },
                    driver: {
                        Name: ''
                    },
                    truck: {
                        Truck: ''
                    },
                    trailer: {
                        Trailer: ''
                    },
                    ReplacementUnit: null
                }
            ],
            rules: {
                required: value => !!value || 'Required.',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || 'Invalid e-mail.';
                }
            },
            readyProducts: false,
            value: 0,
            query: false,
            show: true,
            interval: 0,
            diffDriver: false,
            diffTruck: false,
            diffTrailer: false,
            diffReplUnit: false,
            mailingReady: 'loading',
            loadsReady: 'loading',
            orderDataReady: false,
            emailCounterReference: null,
            thereAreDiffs: false,
            e1: 1,
            reasonsForRevise: [
                {
                    title: 'Quantity Adjustment',
                    reasons: [
                        { model: 'opt1', label: 'Not enough space on site' },
                        { model: 'opt2', label: 'Wrong product' },
                        { model: 'opt3', label: 'No product at the terminal' },
                        {
                            model: 'opt4',
                            label: 'Long lines on the product rack'
                        }
                    ]
                },
                {
                    title: 'Station Change',
                    reasons: [
                        { model: 'opt5', label: 'Divertion' },
                        { model: 'opt6', label: 'Avoid a run out' },
                        {
                            model: 'opt7',
                            label: 'Another driver dropped the site'
                        },
                        { model: 'opt8', label: 'Double dispatch' },
                        { model: 'opt9', label: 'Under construction' }
                    ]
                },
                {
                    title: 'Split Scenarios',
                    reasons: [
                        { model: 'opt10', label: 'Retain due safe fills' },
                        { model: 'opt11', label: 'Retain due a tanks issues' },
                        {
                            model: 'opt12',
                            label: 'Retain due one compartment must remain free'
                        }
                    ]
                },
                {
                    title: 'Terminal Change',
                    reasons: [
                        { model: 'opt13', label: 'No Allocation' },
                        { model: 'opt14', label: 'Outage' },
                        { model: 'opt15', label: 'Not so much line to load' }
                    ]
                },
                {
                    title: 'Account Change',
                    reasons: [{ model: 'opt16', label: 'Loading Information' }]
                },
                {
                    title: 'Book Off',
                    reasons: [{ model: 'opt17', label: 'Shift is removed' }]
                },
                {
                    title: 'Other',
                    reasons: [{ model: 'other', label: 'Other' }]
                }
            ],
            IsOther: false,
            models: {},
            textBody: '',
            groupedReasons: [],
            productInfoHeaders: [
                { text: 'Product', value: 'Product' },
                { text: 'Amount', value: 'DispatchedQuantity' },
                { text: 'Product Code', value: 'ProductCode' }
            ],
            attachPDF: false
        };
    },
    mounted() {
        this.getCurrentShiftInfo();
        this.queryAndIndeterminate();
        this.getDriverMail(this.ShiftDetail);
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        groupReasons: function() {
            console.log(this.models);
            if (this.IsOther) {
                this.groupedReasons.push(this.textBody);
            }

            for (let cat of this.reasonsForRevise) {
                for (let rs of cat.reasons) {
                    if (rs.model == 'other') {
                        continue;
                    }
                    let idx = Object.keys(this.models).indexOf(rs.model);
                    console.log(idx);
                    if (idx != -1) {
                        this.groupedReasons.push(rs.label);
                    }
                }
            }

            console.log(this.groupedReasons);

            /*for (let rs of this.reasonsForRevise) {
                if (rs.model == 'other') { continue; }
                let idx = Object.keys(this.models).indexOf(rs.model);
                console.log(idx);
                if (idx != -1) {
                    this.groupedReasons.push(rs.label);
                }
            }*/
        },
        validateIfThereIsReason: function() {
            if (!Object.keys(this.models).length) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'You have to select at least one reason.'
                });
                return;
            }

            // Verifies that in case of "other" there is a message body
            let idx = Object.keys(this.models).indexOf('other');
            if (idx != -1 && this.models.other && this.textBody.length < 5) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text:
                        'The reason "other" must be at least 5 characters long.'
                });
                return;
            }

            let counter = 0;
            for (let r in this.models) {
                counter++;
                if (this.models[r]) {
                    this.e1 = 2;
                } else if (counter == Object.keys(this.models).length) {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'You have to select at least one reason.'
                    });
                    return;
                }
            }

            this.groupReasons();
        },
        retrieveTextBody: function(evt) {
            this.textBody = evt;
            console.log(this.textBody);
        },
        verifyOther: function(emodel) {
            if (emodel == 'other' && this.IsOther) {
                this.IsOther = false;
                console.log(emodel, this.IsOther);
            } else if (emodel == 'other' && !this.IsOther) {
                this.IsOther = true;
            }
            console.log(this.models);
        },
        showAlert() {
            this.$store.dispatch('setSnackbar', {
                color: 'error',
                text:
                    'There are no changes in the Shift. There is nothing to send to the Driver.'
            });
        },
        queryAndIndeterminate() {
            this.query = true;
            this.show = true;
            this.value = 0;

            setTimeout(() => {
                this.query = false;

                this.interval = setInterval(() => {
                    if (this.value === 100) {
                        clearInterval(this.interval);
                        this.show = false;
                        return setTimeout(this.queryAndIndeterminate, 2000);
                    }
                    this.value += 25;
                }, 1000);
            }, 2500);
        },
        getDriverMail: function(shiftDetail) {
            var str = this.$store;
            var params = {
                shift_detail: shiftDetail
            };
            axios
                .post('/shift-detail/driver-payroll/get/mail', params)
                .then(response => {
                    this.data = response.data['shifts'];
                    this.username = response.data['User']['User'];
                    this.to = this.data[0]['driver']['Email'];
                    this.subject =
                        moment(this.data[0]['shift_header']['Date']).format(
                            'dddd, MMMM DD, YYYY'
                        ) +
                        ' ' +
                        this.data[0]['shift_header']['Shift'] +
                        ' ' +
                        'Work';
                    console.log(this.data);
                })
                .catch(function(error) {
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        getProductsByOrder: async function() {
            var str = this.$store;
            for (let ord of this.NewShiftInfo.ordersShiftData) {
                //console.log(ord.generalOrderData.OrderID)

                await axios
                    .get('order-detail/order/' + ord.generalOrderData.OrderID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        let productsByOrder = response.data.data;
                        console.log('productsByOrder', productsByOrder);
                        ord.orderProductData = [];
                        for (let prd of productsByOrder) {
                            let {
                                Product,
                                ProductID,
                                ProductCode,
                                DispatchedQuantity
                            } = prd;
                            ord.orderProductData.push({
                                Product,
                                ProductID,
                                ProductCode,
                                DispatchedQuantity
                            });
                        }

                        // Ordenamiento tipo burbuja por ProductID
                        let l = ord.orderProductData.length;
                        let aux;

                        for (let i = 1; i < l; i++) {
                            for (let prd = 0; prd < l - i; prd++) {
                                if (
                                    ord.orderProductData[prd].ProductID >
                                    ord.orderProductData[prd + 1].ProductID
                                ) {
                                    aux = ord.orderProductData[prd];
                                    ord.orderProductData[prd] =
                                        ord.orderProductData[prd + 1];
                                    ord.orderProductData[prd + 1] = aux;
                                }
                            }
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                        this.$store.state.dispatch.shiftSummary = false;
                    });
            }

            this.readyProducts = true;
            if (
                this.EmailCounter > 0 &&
                this.NewShiftInfo.generalShiftData.DriverEleosApp == 1
            ) {
                this.generateDiffs();
            } else {
                this.orderDataReady = true;
            }
            console.log('NewShiftInfo', this.NewShiftInfo);
        },
        getCurrentShiftInfo: async function() {
            this.emailCounterReference = this.EmailCounter;
            if (this.NewShiftInfo.generalShiftData.DriverEleosApp == 1) {
                if (this.EmailCounter > 0) {
                    this.$store.state.isLoading = true;
                    var str = this.$store;
                    await axios
                        .get(
                            'shift-diff-checker/current-info/' +
                                this.ShiftDetail,
                            {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            }
                        )
                        .then(response => {
                            this.currentShiftInfo = response.data;
                            console.log(
                                'CurrentShiftInfo',
                                this.currentShiftInfo
                            );
                            this.$store.state.isLoading = false;
                            this.getProductsByOrder();
                        })
                        .catch(function(error) {
                            console.log(error);
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'Something is wrong. Please contact the administrator.'
                            });
                            this.$store.state.isLoading = false;
                            this.$store.state.dispatch.shiftSummary = false;
                        });
                } else {
                    console.log(this.EmailCounter);
                    this.getProductsByOrder();
                }
            } else {
                console.log(
                    'No tiene información en EleosCurrentLoadsByDriver'
                );
                this.getProductsByOrder();
            }
        },
        generateDiffs: function() {
            // Current variables
            const currGenShData = this.currentShiftInfo.generalShiftData;
            const currOrdShData = this.currentShiftInfo.ordersShiftData;
            console.log('CurrentShiftInfo', this.currentShiftInfo);

            // New variables
            const newGenShData = this.NewShiftInfo.generalShiftData;
            const newOrdShData = this.NewShiftInfo.ordersShiftData;
            console.log('NewShiftInfo', this.NewShiftInfo);

            let matchingOrders = [];

            // Diffs at Shift Level
            this.diffDriver = currGenShData.DriverID != newGenShData.DriverID;
            this.diffTruck = currGenShData.TruckID != newGenShData.TruckID;
            this.diffTrailer =
                currGenShData.TrailerID != newGenShData.TrailerID;
            this.diffReplUnit =
                currGenShData.ReplacementUnit != newGenShData.ReplacementUnit;

            this.thereAreDiffs =
                this.diffTruck ||
                this.diffTrailer ||
                this.diffReplUnit ||
                this.diffDriver;

            // Diffs at Order Level
            for (let newOrd = 0; newOrd < newOrdShData.length; newOrd++) {
                for (
                    let currOrd = 0;
                    currOrd < currOrdShData.length;
                    currOrd++
                ) {
                    if (
                        newOrdShData[newOrd].generalOrderData.OrderID ==
                        currOrdShData[currOrd].generalOrderData.OrderID
                    ) {
                        let newOrderData =
                            newOrdShData[newOrd].generalOrderData;
                        let currOrderData =
                            currOrdShData[currOrd].generalOrderData;

                        let newPrdData = newOrdShData[newOrd].orderProductData;
                        let currPrdData =
                            currOrdShData[currOrd].orderProductData;

                        newOrdShData[newOrd].MatchingProductData = [];
                        newOrdShData[newOrd].OnlyNewProductData = [];

                        // Order Diffs
                        newOrderData.orderDiffs = {};
                        newOrderData.orderDiffs.diffLoadNum =
                            newOrderData.LoadNum != currOrderData.LoadNum;
                        newOrderData.orderDiffs.diffLoadNumOrd =
                            newOrderData.LoadNumOrd != currOrderData.LoadNumOrd;
                        newOrderData.orderDiffs.diffPreloaded =
                            newOrderData.OrderStatus !=
                            currOrderData.OrderStatus;
                        newOrderData.orderDiffs.diffTerminal =
                            newOrderData.TerminalID != currOrderData.TerminalID;
                        newOrderData.orderDiffs.diffStation =
                            newOrderData.StationID != currOrderData.StationID;
                        newOrderData.orderDiffs.diffCustomer =
                            newOrderData.CustomerID != currOrderData.CustomerID;
                        newOrderData.orderDiffs.diffSupplier =
                            newOrderData.SupplierID != currOrderData.SupplierID;
                        newOrderData.orderDiffs.diffLoadingNumber =
                            newOrderData.LoadingNumber !=
                            currOrderData.LoadingNumber;
                        newOrderData.orderDiffs.diffShipTo =
                            newOrderData.ShipTo != currOrderData.ShipTo;
                        newOrderData.orderDiffs.diffSpecialInstructions =
                            newOrderData.SpecialInstructions !=
                            currOrderData.SpecialInstructions;
                        newOrderData.orderDiffs.hasDiffs =
                            newOrderData.orderDiffs.diffLoadNum ||
                            newOrderData.orderDiffs.diffLoadNumOrd ||
                            newOrderData.orderDiffs.diffPreloaded ||
                            newOrderData.orderDiffs.diffTerminal ||
                            newOrderData.orderDiffs.diffStation ||
                            newOrderData.orderDiffs.diffCustomer ||
                            newOrderData.orderDiffs.diffSupplier ||
                            newOrderData.orderDiffs.diffLoadingNumber ||
                            newOrderData.orderDiffs.diffShipTo ||
                            newOrderData.orderDiffs.diffSpecialInstructions;
                        newOrderData.orderDiffs.hasPrdDiffs = false;
                        if (!this.thereAreDiffs) {
                            this.thereAreDiffs =
                                newOrderData.orderDiffs.hasDiffs;
                        }

                        // Product Diffs
                        for (
                            let newPrd = 0;
                            newPrd < newPrdData.length;
                            newPrd++
                        ) {
                            for (
                                let currPrd = 0;
                                currPrd < currPrdData.length;
                                currPrd++
                            ) {
                                if (
                                    newPrdData[newPrd].ProductID ==
                                        currPrdData[currPrd].ProductID &&
                                    newPrdData[newPrd].ProductCode ==
                                        currPrdData[currPrd].ProductCode &&
                                    newPrdData[newPrd].Product ==
                                        currPrdData[currPrd].Product
                                ) {
                                    currPrdData[currPrd].IsMatch = true;
                                    newPrdData[newPrd].diffDispatchedQuantity =
                                        newPrdData[newPrd].DispatchedQuantity !=
                                        currPrdData[currPrd].DispatchedQuantity;
                                    if (!this.thereAreDiffs) {
                                        this.thereAreDiffs =
                                            newPrdData[
                                                newPrd
                                            ].diffDispatchedQuantity;
                                    }
                                    if (!newOrderData.orderDiffs.hasPrdDiffs) {
                                        newOrderData.orderDiffs.hasPrdDiffs =
                                            newPrdData[
                                                newPrd
                                            ].diffDispatchedQuantity;
                                    }
                                    newOrdShData[
                                        newOrd
                                    ].MatchingProductData.push({
                                        Current: currPrdData[currPrd],
                                        New: newPrdData[newPrd]
                                    });
                                    break;
                                }

                                if (currPrd == currPrdData.length - 1) {
                                    newOrdShData[
                                        newOrd
                                    ].OnlyNewProductData.push(
                                        newPrdData[newPrd]
                                    );
                                    newOrderData.orderDiffs.hasPrdDiffs = true;
                                    if (!this.thereAreDiffs) {
                                        this.thereAreDiffs = true;
                                    }
                                }
                            }
                        }

                        newOrdShData[
                            newOrd
                        ].OnlyCurrentProductData = currPrdData.filter(
                            prd => prd.IsMatch != true
                        );
                        if (
                            newOrdShData[newOrd].OnlyCurrentProductData
                                .length !== 0
                        ) {
                            newOrderData.orderDiffs.hasPrdDiffs = true;
                            if (!this.thereAreDiffs) {
                                this.thereAreDiffs = true;
                            }
                        }

                        this.OrderData.push({
                            Current: currOrdShData[currOrd],
                            New: newOrdShData[newOrd]
                        });
                        matchingOrders.push(
                            currOrdShData[currOrd].generalOrderData.OrderID
                        );
                        break;
                    }

                    if (currOrd == currOrdShData.length - 1) {
                        this.OrderData.push({
                            Current: false,
                            New: newOrdShData[newOrd]
                        });
                        if (!this.thereAreDiffs) {
                            this.thereAreDiffs = true;
                        }
                    }
                }
            }

            // Check that matchingOrders is empty
            if (matchingOrders.length == 0) {
                for (let ord of currOrdShData) {
                    this.OrderData.push({ Current: ord, New: false });
                }
                if (!this.thereAreDiffs) {
                    this.thereAreDiffs = true;
                }
            } else {
                for (let ord = 0; ord < currOrdShData.length; ord++) {
                    for (
                        let ordId = 0;
                        ordId < matchingOrders.length;
                        ordId++
                    ) {
                        if (
                            currOrdShData[ord].generalOrderData.OrderID ==
                            matchingOrders[ordId]
                        ) {
                            break;
                        } else if (ordId == matchingOrders.length - 1) {
                            this.OrderData.push({
                                Current: currOrdShData[ord],
                                New: false
                            });
                            if (!this.thereAreDiffs) {
                                this.thereAreDiffs = true;
                            }
                        }
                    }
                }
            }

            this.orderDataReady = true;
            console.log('OrderData: ', this.OrderData);
            console.log(this.orderDataReady);
        },
        emailConfirm: function(shiftDet) {
            var str = this.$store;
            let size = this.cc.length;
            let cc = '';

            console.log(shiftDet);

            if (this.cc[size - 1] == ';') {
                cc = this.cc.substring(0, this.cc.length - 1);
            } else {
                cc = this.cc;
            }

            let sizeTo = this.to.length;
            let to = '';

            if (this.to[sizeTo - 1] == ';') {
                to = this.to.substring(0, this.to.length - 1);
            } else {
                to = this.to;
            }

            var check = this.checkEmail(to, cc);

            if (check == 'Okey') {
                this.$store.state.dispatch.processVerifier = true;
                if (this.NewShiftInfo.generalShiftData.DriverEleosApp != 1) {
                    this.sendDriverMail(shiftDet, cc, to);
                } else {
                    this.setLoadsByDriver(shiftDet, cc, to);
                }
            } else {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text:
                        "Email format error. Please check the address(es) you're trying to reach and try again"
                });
            }
        },
        checkEmail: function(to, cc) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,2}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let emailTo = to.split(';');
            let emailCc = cc.split(';');
            let emails = null;

            if (cc != '') {
                emails = emailTo.concat(emailCc);
            } else {
                emails = emailTo;
            }

            let status = 'Okey';

            emails.forEach(mail => {
                if (!pattern.test(mail)) {
                    status = 'Error';
                }
            });

            return status;
        },
        sendDriverMail: function(shiftDet, cc, to) {
            var str = this.$store;

            var params = {
                shift_detail: shiftDet,
                shift_info: this.NewShiftInfo,
                from: this.from,
                cc: cc.split(';'),
                to: to.split(';'),
                subject: this.subject,
                username: this.username,
                email_counter: this.EmailCounter,
                diff_truck: this.diffTruck,
                diff_trailer: this.diffTrailer,
                diff_replUnit: this.diffReplUnit,
                dvr_eleos_app: this.NewShiftInfo.generalShiftData
                    .DriverEleosApp,
                attach_pdf: this.attachPDF
            };
            console.log('Params', params);

            axios
                .post('shift-detail/driver-payroll/mail', params)
                .then(response => {
                    console.log(response);
                    this.mailingReady = 'success';

                    setTimeout(() => {
                        if (this.mailingReady && this.loadsReady) {
                            this.$emit('close');
                            this.$store.state.dispatch.processVerifier = false;
                            this.$store.state.dispatch.shiftSummary = false;
                        }
                    }, 3000);
                })
                .catch(function(error) {
                    console.log(error);
                    this.mailingReady = 'error';
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        setLoadsByDriver: function(shiftDetail, cc, to) {
            var str = this.$store;
            //console.log(shiftDetail)

            let params = {
                shift_detail: shiftDetail,
                diff_truck: this.diffTruck,
                diff_trailer: this.diffTrailer,
                diff_replUnit: this.diffReplUnit,
                truck: this.data[0].truck.Truck,
                trailer: this.data[0].trailer.Trailer,
                replUnit: this.data[0].ReplacementUnit,
                reviseReasons: this.groupedReasons
            };
            console.log(params);

            axios
                .post('shift-detail/driver-loads/' + shiftDetail, params)
                .then(response => {
                    console.log(response.data);
                    this.loadsReady = 'success';
                    this.sendDriverMail(shiftDetail, cc, to);
                })
                .catch(function(error) {
                    console.log(error);
                    this.loadsReady = 'error';
                    // Failed to upload orders to the driver
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        }
    }
};
</script>
<style>
.panels-container {
    width: 100%;
    padding: 15px 0 0;
    margin: 0 auto;
}
.toolbar-container {
    width: 100%;
    margin: 0 auto;
}
.diff-current {
    background-color: #ec5d5d;
    padding: 5px;
    border-radius: 5px;
}
.diff-new {
    background-color: #5ed291;
    padding: 5px;
    border-radius: 5px;
}
</style>
